var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgT3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 156,
    height: 192,
    viewBox: "0 0 156 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(-159.5 -1995)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(186.5 2114)",
    fill: "#fcd578",
    fontSize: 100,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.014em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19.45,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: "IN",
    transform: "translate(232.5 2114)",
    fill: "#fcd578",
    fontSize: 70,
    fontFamily: "Oswald-Light, Oswald",
    fontWeight: 300,
    letterSpacing: "-0.014em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.48,
    y: 0
  }, "IN")), /*#__PURE__*/React.createElement("text", {
    id: "_7",
    "data-name": 7,
    transform: "translate(279.5 2114)",
    fill: "#fcd578",
    fontSize: 100,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.014em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.95,
    y: 0
  }, "7")), /*#__PURE__*/React.createElement("text", {
    id: "women",
    transform: "translate(237.5 2140)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.27,
    y: 0
  }, "WOMEN")), /*#__PURE__*/React.createElement("text", {
    id: "have_been_stalked_by_an_intimate_partner",
    "data-name": "have been stalked by an intimate partner",
    transform: "translate(237.5 2164)",
    fill: "#1d1d1d",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -62.82,
    y: 0
  }, "have been stalked"), /*#__PURE__*/React.createElement("tspan", {
    x: -77.56,
    y: 20
  }, "by an intimate partner")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT3);
export default __webpack_public_path__ + "static/media/t3.968e9d721e42d60eb775eb9de7ce92ce.svg";
export { ForwardRef as ReactComponent };